import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Button, Flex, useStyleConfig} from '@chakra-ui/react'

const AddReviews = (props) => {
    const styles = useStyleConfig('AddReviews', props)
    const {reviewCount, writeReviewLoading, onClick} = props

    return (
        <Flex {...styles.container}>
            <Button
                {...styles.button}
                disabled={writeReviewLoading}
                isLoading={writeReviewLoading}
                onClick={onClick}
                data-testid="add-reviews"
            >
                <FormattedMessage defaultMessage="Write a Review" id="reviews.add" />
            </Button>
            {reviewCount ? (
                <Flex {...styles.reviewCount} data-testid="review-count">
                    {reviewCount}&nbsp;
                    <FormattedMessage defaultMessage="Reviews" id="reviews.reviews" />
                </Flex>
            ) : null}
        </Flex>
    )
}

AddReviews.propTypes = {
    reviewCount: PropTypes.number,
    writeReviewLoading: PropTypes.bool,
    onClick: PropTypes.func
}

export default AddReviews
